"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYSTEM_CONTEXT_MODERATORS = void 0;
exports.SYSTEM_CONTEXT_MODERATORS = [
    "natarius",
    "collinsemasi",
    "kerry",
    "dirk-builds",
    "dominic-dev",
    "brooks",
    "jeffwilde",
    "jharwinbarrozo",
    "ryanf",
];
//# sourceMappingURL=moderators.js.map